// extracted by mini-css-extract-plugin
export default {"overlayStyle":"highlight_overlayStyle__ueDAZ","blink":"highlight_blink__SZA9D"};